<script>
import ScanHistory from "./components/ScanHistory";
import AdjustCurlyConfiguration from "./components/AdjustCurlyConfiguration";
import AdjustKFBConfiguration from "./components/AdjustKFBConfiguration";
import AdjustTShirtConfiguration from "./components/AdjustTShirtConfiguration";
import AdjustHoodieConfiguration from "./components/AdjustHoodieConfiguration";

export default {
  components: {
    ScanHistory,
    AdjustKFBConfiguration,
    AdjustCurlyConfiguration,
    AdjustTShirtConfiguration,
    AdjustHoodieConfiguration
  },

  data() {
    return {
      productOrder: {},
      items: [],
      scanHistory: [],
      error: null,
    };
  },

  mounted() {
    this.getProductOrderData();
  },

  methods: {
    async getProductOrderData() {
      this.error = null;
      try {
        let res = await axios.get("product_orders/details/" + this.$route.params.id);
        this.productOrder = res.data.data.order;
        this.items = res.data.data.items;
        this.scanHistory = res.data.data.scanHistory;
      } catch (error) {
        this.error = "Product order not found";
      }
    },

    async printProductionSheet(item) {
      await ezy.openPDFInNewWindow(`production_items/production_sheet/${item.id}`)
    },

    async printPattern(item) {
      await ezy.openPDFInNewWindow(`production_items/pattern/${item.id}`)
    },

    confirmMarkOrderAsFinished() {
      Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "CONFIRM",
      }).then((result) => {
        if (result.value) {
          this.markOrderAsFinished();
        }
      });
    },

    async markOrderAsFinished() {
      let status = 'sent_to_germany';

      try {
        if (this.productOrder.status === 'sent_to_germany') {
          toastr.error("Already sent to Germany");
          return
        }

        this.errors = {};
        let res = await axios.post(`product_orders/update-order-configuration/${this.productOrder.id}`, {status});
        if (res) {
          toastr.success("Successfully Updated");
          this.getProductOrderData();
        }
      } catch (error) {
        this.errors = error.response.data.errors;
      }

    },
    back() {
      window.history.back();
    }

  }
}

</script>

<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-body">
        <div class="col-md-2 text-center">
          <button class="btn btn-block btn-secondary" @click="back">
            &laquo; Back
          </button>
        </div>
      </div>
    </div>
    <div class="grid bg-white">
      <div class="grid-title">
        <div class="flex flex-wrap">
          <h5 class="inline">
            <strong>Order ID #{{ productOrder.id }}</strong>
          </h5>
          <span class="mx-3">
                |
            </span>
          <h5 class="inline">
            <strong>Product Type</strong> - {{ productOrder.product_type }}
            {{ productOrder.product_category ? " - " + productOrder.product_category : "" }}
          </h5>
        </div>
      </div>
      <div class="grid-body" v-if="error">
        <div class="alert alert-danger" role="alert">
          <h4 class="alert-heading">Error</h4>
          <p>{{ error }}</p>
        </div>
      </div>

      <div class="grid-body" v-if="productOrder">
        <table id="productOrder-detail-table" class="table table-bordered">
          <thead>
          <tr>
            <th>Item ID</th>
            <th>Product</th>
            <th>Status</th>
            <th>Days in Status</th>
            <th>Age</th>
            <th class="text-center">Documents</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="text-bold">
              <router-link :to="'/production_item/overview/all/' + productOrder.id"
              >#{{ item.id }}
              </router-link>
            </td>
            <td>{{ productOrder.product_name }}</td>
            <td><span :class="'item-status ' + item.status">{{ item.status }}</span></td>
            <td class="text-center">{{ item.days_in_step }}</td>
            <td class="text-center">{{ item.age }}</td>
            <td class="text-bold text-center">
              <a v-if="item.can_print_production_sheet"
                @click="printProductionSheet(item)"
                :class="{
                    'btn btn-primary btn-sm': !item.is_production_sheet_printed,
                    'btn btn-success btn-sm':
                      item.is_production_sheet_printed,
                  }"
              >
                Print Production Sheet
              </a>
              <span v-else class="btn btn-sm btn-disabled">Print Production Sheet</span>
              <a
                    v-if="item.can_print_pattern"
                @click="printPattern(item)"
                :class="{
                    'btn btn-primary btn-sm': !productOrder.is_pattern_printed,
                    'btn btn-success btn-sm':
                      productOrder.is_pattern_printed,
                  }"
              >
                Print Pattern
              </a>
              <span v-else class="btn btn-sm btn-disabled">Print Pattern</span>
            </td>
          </tr>
          </tbody>
        </table>
        <div id="update-form-and-status-date" class="row mb-10">
          <div class="col-md-6">
            <div v-if="productOrder.product_category === 'curly'" class="col-md-12">
              <AdjustCurlyConfiguration :productOrder="productOrder"/>
            </div>
            <div v-else-if="productOrder.product_category === 'kellerfaltenbluse'" class="col-md-12">
              <AdjustKFBConfiguration :productOrder="productOrder"/>
            </div>
            <div v-else-if="productOrder.product_category === 't-shirt'" class="col-md-12">
              <AdjustTShirtConfiguration :productOrder="productOrder"/>
            </div>
            <div v-else-if="productOrder.product_category === 'hoodie'" class="col-md-12">
              <AdjustHoodieConfiguration :productOrder="productOrder"/>
            </div>
            <div class="col-md-12 mt-3">
              <button class="btn btn-danger btn-block" @click="confirmMarkOrderAsFinished()">
                Finish Manually
              </button>
            </div>
          </div>
          <div class="col-md-6 float-right">
            <div v-if="scanHistory.length > 0">
              <ScanHistory :history="scanHistory"/>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
